import type { Padding } from '../utils';
import { matrices } from './matrices';
import type { CanvasTransform } from './types';

const toTransformAttr = (m: DOMMatrixReadOnly): string =>
  `matrix(${m.a}, ${m.b}, ${m.c}, ${m.d}, ${m.e}, ${m.f})`;

export const dom = {
  // Returns SVG transform attribute for canvas group element
  canvasTransform: (t: CanvasTransform): string =>
    toTransformAttr(matrices.canvas.toViewport(t)),

  // Returns SVG transform attribute for content group element
  contentTransform: (padding: Padding, t: CanvasTransform): string =>
    toTransformAttr(matrices.content.toCanvas(padding, t)),
};
